/* eslint-disable no-underscore-dangle */
import axios from 'axios';
import { changeSupplyItemDateQuery } from './queries';

const changeSupplyItemDate = async ({ id, date }) => {
    try {
        const scheduleItemsQuery = changeSupplyItemDateQuery({ id, date });
        const scheduleItemsRequest = axios.put(scheduleItemsQuery);
        const { data } = await scheduleItemsRequest;
        return data;
    } catch (err) {
        // eslint-disable-next-line
        console.log(err);
        throw new Error('Unable to process request.');
    }
};

export default changeSupplyItemDate;
